import axios from 'axios'
import {
  AuthModel,
  ConfirmarModel,
  RecuperarActiveModel,
  RecuperarModel,
  RegisterModel,
  RegisterModel2,
  UserModel,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL2
const API_URL2 = process.env.REACT_APP_API_URL2

export const LOGIN_URL2 = `${API_URL2}/Autenticacion/login`
export const CONFIRMEMAIL_URL = `${API_URL2}/Autenticacion/ConfirmarEmail`
export const REFRESHTOKEN_URL = `${API_URL2}/Autenticacion/RefreshToken`
export const GETUSER_URL = `${API_URL2}/Autenticacion/getUserByToken`
export const RECUPERARPASSWORD_URL = `${API_URL2}/Autenticacion/Recuperar`
export const REGISTER_URL2 = `${API_URL2}/Autenticacion/Registrar`

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/usuario/nombre`
export const LOGIN_URL = `${API_URL}/usuario/login`
export const REGISTER_URL = `${API_URL}/usuario/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/usuario/Recuperar`
// export const NEW_PASSWORD_URL = `${API_URL}/usuario/NuevaContrasena`
export const NEW_PASSWORD_URL = `${API_URL}/Autenticacion/CambiarContraseña`
export const CODE_ACTIVE_URL = `${API_URL}/usuario/getcodesession`
export const VALIDATE_SESSION_URL = `${API_URL}/usuario/validarsession`
export const VALIDATE_ACTIVATE_URL = `${API_URL}/usuario/validarcodigo`

export const FILTROSPAISES_URL = `${API_URL}/cat_Pais/Read_All`



// Server should return AuthModel
//EL FRONT ENVÍA(EMAIL,PASSWORD Y LENGUAJE)
//RECIBE LO QYE HAY EN AuthModel
// export function login(Email: string, Password: string, Language: string) {
//   return axios.post<AuthModel>(LOGIN_URL, {
//     Email,
//     Password,
//     Language,
//   })
// }

// export function login2(email: string|undefined, password: string|undefined, app: string,lang:string) {
//   return axios.post<AuthModel>(LOGIN_URL2, {
//     email,
//     password,
//     app,
//     lang
//   })
// }

export function login(email: string|undefined, password: string|undefined, app: string,lang:string) {
  return axios.post<AuthModel>(LOGIN_URL2, {
    email,
    password,
    app,
    lang
  })
}


export function activarUsuario(email: string,clave_confirmacion:String,language:string) {
  return axios.post<ConfirmarModel>(CONFIRMEMAIL_URL, {
    email,
    clave_confirmacion,
    language
  })
}

//Register Heomoney
export function register2(
  apellido_paterno: string,
  apellido_materno: string,
  nombre1: string,
  nombre2: string,
  email: string,
  fecha_nacimiento: string,
  password: string,
  id_pais_localizacion: string,
  app: string,
  lang: string
) {
  return axios.post<RegisterModel2>(REGISTER_URL2, {
    apellido_paterno,
    apellido_materno,
    nombre1,
    nombre2,
    email,
    fecha_nacimiento,
    password,
    id_pais_localizacion,
    app,
    lang,
  })
}


// Server should return AuthModel
export function register(
  Name: string,
  LastName: string,
  Email: string,
  Password: string,
  PasswordConfirmed: string,
  Language: string
) {
  return axios.post<RegisterModel>(REGISTER_URL, {
    Name,
    LastName,
    Email,
    Password,
    PasswordConfirmed,
    Language,
  })
}



// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string, language: string) {
  return axios.post<RecuperarModel>(REQUEST_PASSWORD_URL, {
    email,
    language,
  })
}

export function recuperarcontraseña(email: string,language:string) {
  return axios.post<RecuperarModel>(RECUPERARPASSWORD_URL, {
    email,
    language
  })
}

export function getCodeActive(Email: string) {
  return axios.post<RecuperarActiveModel>(CODE_ACTIVE_URL, {
    Email,
  })
}

export function validateActive(Email: string) {
  return axios.post<RegisterModel>(VALIDATE_SESSION_URL, {
    Email,
  })
}

export function userActivate(Email: string, codeSession: String) {
  return axios.post<RegisterModel>(VALIDATE_ACTIVATE_URL, {
    Email,
    codeSession,
  })
}

export function newPassword(email: string, newPassword: string, clave_recuperacion: string, lang:string) {
  return axios.post<RecuperarModel>(NEW_PASSWORD_URL, {
    email,
    newPassword,
    clave_recuperacion,
    lang,
  })
}

export function getUserByToken(token:string|undefined,app: string) {
  return axios.post<UserModel>(GETUSER_URL, {
    w_Token: token,
    app
  })
}

export function refreshToken(token_expired:string|undefined,app: string) {
  return axios.post<AuthModel>(REFRESHTOKEN_URL, {
    token_expired,
    app
  })
}